import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-element" }


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationEllipsis',
  emits: ["onClicked"],
  setup(__props) {


// currently not emitting anything, needs scoping of the event

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "content",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClicked')))
    }, "...")
  ]))
}
}

})